import { Component, Input } from '@angular/core';

@Component({
  selector: 'kt-registration-progress-bar',
  templateUrl: './registration-progress-bar.component.html',
  styleUrls: ['./registration-progress-bar.component.scss'],
  standalone: false,
})
export class RegistrationProgressBarComponent {
  @Input() disableCompanyVerification: boolean;
  @Input() success: boolean;
  @Input() isCargoWallet: boolean;
  @Input() steps: string[] = [
    $localize`:@@registration.sign-up:Sign Up`,
    $localize`:@@registration.company-verification:Company Verification`,
  ];
}
